import { Helmet } from "react-helmet";
import { Flex, Button, Text } from "@chakra-ui/react";
import { IoMdArrowBack } from "react-icons/io";
import withNavElements from "../../components/withNavElements";
import { useHistory } from "react-router-dom";
import SectionHeader from "../../components/SectionHeader";

const DashboardOrdersPage = () => {
    const history = useHistory();
    return (
        <Flex
            flexDir="column"
            w="100%"
            minH="80vh"
            pt="120px"
            px={{ base: "40px", md: "40px" }}
        >
            <Helmet>
                <title>Dashboard - Orders</title>
            </Helmet>
            <Flex flexDir="column" >
                <SectionHeader
                    title="Pedidos"
                    description="Revisa los pedidos de tus clientes y actualiza su estado."
                />
            </Flex>
        </Flex>
    )
}

export default withNavElements(DashboardOrdersPage);